import useClientConfig from "../common/hooks/clientConfigHook"
import TextInput from "../common/components/TextInput";
import { useTranslation } from "react-i18next";
import { Row, Col } from "../common/components/Grid";
import { Button } from "react-bootstrap";
import { geoSearch, reverseGeoCode } from "../utils/geoUtilities";
import useNetwork from "../common/hooks/networkHook";
import Icon from "../common/components/Icon";
import { useCallback, useEffect, useState } from "react";

const PositionInput = ({ id, position: { latitude, longitude, w3w }, onChange, disableRevCode, live, ...props}) => {
    const { t } = useTranslation();
    const network = useNetwork();
    const clientConfig = useClientConfig();
    const [coords, setCoords] = useState({});

    useEffect(() => setCoords(coords => ({ ...coords, latitude})), [latitude]);

    useEffect(() => setCoords(coords => ({ ...coords, longitude})), [longitude]);

    const doRevCode = async () => {
        try {
            const searchResult = await geoSearch(network, w3w);
            if (searchResult?.length === 1 && searchResult[0].display_name === w3w) {
                const pos = await reverseGeoCode(network, searchResult[0].lat, searchResult[0].lon)
                if (pos?.display_name) {
                    onChange?.({ location: pos?.display_name })
                }
            }
        } catch (err) {
            console.log('Revcode failed with error:', err);
        }
    }

    const coordsValid = useCallback((lat, long) => {
        // both values null
        if ((!lat || lat === '') && (!long || long === '')) {
            return true;
        }
        //both values set
        if (lat && lat !== '' && long && long !== '') {
            return true;
        }
        return false;

    }, []);

    const handleCoordChange = useCallback((field, value) => {
        setCoords((prevCoords) => {
            const nextCoords = { ...prevCoords, [field]: value };
            if (coordsValid(nextCoords.latitude, nextCoords.longitude)) {
                onChange?.(nextCoords);
            }
            return nextCoords;
        });
    }, [coordsValid, onChange, setCoords]);

    const handleLatChange = useCallback((lat) => {
        handleCoordChange('latitude', lat);
    }, [handleCoordChange]);

    const handleLonChange = useCallback((long) => {
        handleCoordChange('longitude', long);
    }, [handleCoordChange]);

    const revcodeButton = !disableRevCode && clientConfig.enableGeocoding ? <Button variant="default" disabled={!w3w} onClick={doRevCode}><Icon variant="solid" kind="map-marker-alt"></Icon></Button> : null;

    if (clientConfig.altcoordMode === 'none') {
        return <Row id={`${id}_positionInput`}>
            <Col>
                <TextInput live={live} value={coords.latitude} placeholder={t('latitude')} onChange={handleLatChange} {...props}></TextInput>
            </Col>
            <Col>
                <TextInput live={live} value={coords.longitude} placeholder={t('longitude')} onChange={handleLonChange} {...props}></TextInput>
            </Col>
        </Row>
    } else {
        return <Row id={`${id}_w3wInput`}>
            <Col>
                <TextInput live={live} value={w3w} placeholder={clientConfig.altcoordLbl} onChange={w3w => onChange?.({ w3w })} appendCtrl={revcodeButton} {...props}></TextInput>
            </Col>
        </Row>
    }
}

export default PositionInput;